import React, { useEffect, useState, useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  CircularProgress,
  Button,
  Box,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";

const PaymentProcessingModal = ({ open, onClose, checkPaymentStatus }: any) => {
  const [attemptCount, setAttemptCount] = useState(0);
  const [status, setStatus] = useState("processing"); // "processing" | "success" | "failed"
  const intervalRef: any = useRef(null);

  useEffect(() => {
    if (open) {
      setStatus("processing");
      setAttemptCount(0);

      intervalRef.current = setInterval(async () => {
        setAttemptCount((prev) => {
          const next = prev + 1;

          if (next > 5) {
            clearInterval(intervalRef.current);
            setStatus("failed");
            return next;
          }

          return next;
        });

        try {
          const response = await checkPaymentStatus();
          if (response?.status === "success") {
            clearInterval(intervalRef.current);
            setStatus("success");
          } else if (response?.status === "failed") {
            clearInterval(intervalRef.current);
            setStatus("failed");
          }
        } catch (error) {
          console.error("Error checking status:", error);
        }
      }, 10000); // 10s
    }

    return () => clearInterval(intervalRef.current);
  }, [open, checkPaymentStatus]);

  const renderContent = () => {
    if (status === "processing") {
      return (
        <>
          <CircularProgress sx={{ mb: 2 }} />
          <Typography>Processing your payment...</Typography>
          <Typography variant="caption">
            Please wait while we process your payment
          </Typography>
        </>
      );
    }

    if (status === "success") {
      return (
        <Box textAlign="center">
          <CheckCircleIcon color="success" sx={{ fontSize: 50, mb: 2 }} />
          <Typography variant="h6">Payment Successful!</Typography>
        </Box>
      );
    }

    if (status === "failed") {
      return (
        <Box textAlign="center">
          <ErrorIcon color="error" sx={{ fontSize: 50, mb: 2 }} />
          <Typography variant="h6" color="error">
            Payment Failed
          </Typography>
          <Typography variant="body2">
            We could not verify your payment. Please try again later.
          </Typography>
        </Box>
      );
    }
  };

  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogContent
        sx={{
          py: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {renderContent()}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentProcessingModal;
